import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { AuthContext } from "../../Context/AuthContext";
import UniversalNotificationBell from "../../Admin/Components/Common/UniversalNotificationBell";

function Navbar() {
  const navigate = useNavigate();
  const { logout, workingHours, breakStatus, isOnBreak, startBreak, resumeBreak } = useContext(AuthContext);

  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  }, []);

  const employeeId = user?.employeeId || user?._id;
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Format decimal hours (from Context) into HH:mm:ss
  const formatTimeDisplay = (decimalHours) => {
    const totalSeconds = Math.floor(decimalHours * 3600);
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const handleLogout = async () => {
    try {
      if (employeeId) {
        await axios.post(`${API_URL}/api/checkout`, { employeeId });
      }
    } catch (err) {
      // Do not block logout if checkout API fails
      console.error("Checkout error on logout:", err);
    } finally {
      if (typeof logout === "function") logout();
      localStorage.clear();
      navigate("/login");
    }
  };

  return (
    <nav style={{ background: "#003e6d", color: "white", height: "70px", display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "0 20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
        <UniversalNotificationBell />

        <div>
          <small>Current Time</small>
          <div>{currentTime.toLocaleTimeString("en-IN", { hour12: false })}</div>
        </div>

        <div>
          <small>Working Hours</small>
          <div style={{ color: "#FFD700" }}>{formatTimeDisplay(workingHours)}</div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{
            display: "inline-block",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            background: isOnBreak ? "#F59E0B" : "#10B981",
            boxShadow: isOnBreak ? "0 0 8px #F59E0B" : "0 0 8px #10B981"
          }}></span>
          <span style={{ fontWeight: 600, fontSize: "14px" }}>{isOnBreak ? "On Break" : "Working"}</span>
        </div>

        <button
          onClick={isOnBreak ? resumeBreak : startBreak}
          style={{
            background: isOnBreak ? "#10B981" : "#F59E0B",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "6px 14px",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: "14px"
          }}
        >
          {isOnBreak ? "Resume" : "Break"}
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              background: "white",
              borderRadius: "8px",
              padding: "6px 12px",
              color: "#111827",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FaUserCircle size={18} /> {user?.ename || "Employee"}
          </div>

          <button
            onClick={handleLogout}
            style={{
              background: "#ef4444",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "6px 12px",
              fontWeight: 600,
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;


